import React from 'react';
import './App.css';
import {Thing} from 'upset-react';

function App() {
  return (
    <div className="App">
        <Thing/>
    </div>
  );
}

export default App;
